import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { Spinner } from "@/components/Spinner";
import { useUserData } from "../../lib/hooks/useUserData";
import { formSchema } from "../config";
import type { FormSchema } from "../types";
import { UpdateProfileForm } from "./components/UpdateProfileForm";

export const Profile = () => {
	const { userData, updateUserData, isLoadingGet, isLoadingUpdate } =
		useUserData();

	const values: FormSchema = {
		imageId: userData?.imageId || 0,
		userName: userData?.userName ?? "",
		aboutMe: userData?.aboutMe || "",
		goal: userData?.goal || "",
		firstName: userData?.firstName || "",
		lastName: userData?.lastName || "",
		email: userData?.email || "",
		phone: userData?.phone || "",
		publicProfile: userData?.publicProfile || false,
		showOnlineAddresses: userData?.showOnlineAddresses || false,
		investingCharacteristics: {
			options: userData?.investingCharacteristics?.options || 1,
			riskTolerance: userData?.investingCharacteristics?.riskTolerance || 1,
			investmentHorizon:
				userData?.investingCharacteristics?.investmentHorizon || 1,
			equities: userData?.investingCharacteristics?.equities || 1,
			etfFunds: userData?.investingCharacteristics?.etfFunds || 1,
			futures: userData?.investingCharacteristics?.futures || 1,
			fixedIncome: userData?.investingCharacteristics?.fixedIncome || 1,
			investingStyle: {
				value:
					userData?.investingCharacteristics?.investingStyle?.value || false,
				growth:
					userData?.investingCharacteristics?.investingStyle?.growth || false,
				income:
					userData?.investingCharacteristics?.investingStyle?.income || false,
				all: userData?.investingCharacteristics?.investingStyle?.all || false,
			},
		},
		onlineAddresses: {
			website: userData?.onlineAddresses?.website || "",
			twitter: userData?.onlineAddresses?.twitter || "",
		},
	};

	const form = useForm<FormSchema>({
		resolver: zodResolver(formSchema),
		values,
		mode: "onBlur",
	});

	if (!userData || isLoadingGet) {
		return <Spinner />;
	}

	return (
		<FormProvider {...form}>
			<UpdateProfileForm
				form={form}
				userData={userData}
				updateUserData={updateUserData}
				isLoadingUpdate={isLoadingUpdate}
			/>
		</FormProvider>
	);
};
